const softRing = require('./soft_ring.wav');

export const sounds = {
  softRing,
};
